/* global Departments, Units */
import 'lib/units'
window.Departments || (window.Departments = {})

Departments.addressesSelect = function () {
  $(document).off('change.relatedDepartments').on('change.relatedDepartments', '#position_department_id, #user_related_department_ids', function () {
    if (document.querySelectorAll('select.department-related-addresses').length === 0) return

    const DepartmentId = $(this).val()
    $.ajax({
      url: '/addresses/for_departments',
      method: 'GET',
      dataType: 'json',
      data: { department_ids: DepartmentId }
    }).done(data => {
      if (data.length > 0) {
        Units.populate_select2('select.department-related-addresses', data)
      } else {
        const UnitIds = $('#position_unit_id, #user_related_unit_ids').val()
        Units.updateAddressesByUnit(UnitIds)
      }
    })
  })
}
